import {
  DateRangeType,
  ENUM_DATE_RANGE,
  getDateRangeSelector
} from '@cokitchen/cokitchen-components';
import { BackIcon } from 'cokitchen-icons';
import RecentOrderCard from 'components/logistics/user-profile-cards/recent-order-cards';
import UserDetailDashboard from 'components/logistics/user-profile-cards/user-detail-dashboard';
import { UserType } from 'models/user.model';
import UserProfileGeneralInfo from 'pages/search/user-profile-general-info';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { apiService } from 'utils/api';
import { getInitialRoute } from 'utils/role-config';

const UserProfile = () => {
  const { user_id } = useParams();
  const [user, setUser] = useState<UserType | null>(null);
  const [dateRange, setDateRange] = useState<DateRangeType>({
    range: ENUM_DATE_RANGE.THIS_WEEK,
    date: getDateRangeSelector(ENUM_DATE_RANGE.THIS_WEEK)
  });
  const [loading, setLoading] = useState(false);

  const getUser = async () => {
    try {
      setLoading(true);
      const res = await apiService.get(`user/one/${user_id}`, {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      setUser(res?.data?.data);
    } catch (err) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  return (
    <div className='flex flex-col gap-6'>
      <Link
        to={getInitialRoute()}
        className='text-sm text-[#595959] flex gap-2 items-center w-[220px]'>
        <BackIcon />
        <p>Back</p>
      </Link>
      {loading ? (
        <div className='w-full min-h-[50vh] flex items-center justify-center'>
          <p>Loading...</p>
        </div>
      ) : user ? (
        <div>
          <UserDetailDashboard user={user} dateRange={dateRange} onChange={setDateRange} />
          <UserProfileGeneralInfo user={user} />
          <p className='font-medium text-xl pb-4 pt-6'>Recent Orders</p>
          <RecentOrderCard user={user} dateRange={dateRange} />
        </div>
      ) : (
        <div className='w-full min-h-[50vh] flex items-center justify-center'>
          <p>User not found</p>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
